import {NavLink} from 'react-router-dom';
import {
    Box,
    Breadcrumbs,
} from '@mantine/core';

import config from '../config';

// ⚠️ THE BREADCRUMB GOES THROUGH THE ZONE, because that is the only way back.
//
// A record has no identity outside its zone, so the trail is
// Home → Zones → <this zone> → Records. The zone link carries the connectionId,
// because `/zones/:zoneId` alone cannot address a zone — getDnsZone needs both.
export const IndexPageNavigation = (
    {
        zoneId,
        connectionId,
        zoneName,
    }: {
        zoneId: string,
        connectionId?: string,
        zoneName?: string,
    },
) => {

    const breadcrumbs = [
        {
            title: 'Home',
            href: '/dashboard',
        },
        {
            title: 'Zones',
            href: config.zonesBasePath,
        },
        {
            // The zone's NAME where it has loaded; its id is opaque and means
            // nothing to an operator, so it is the fallback rather than the
            // first choice.
            title: zoneName ?? zoneId,
            href: config.zonePath(zoneId, connectionId),
        },
        {title: config.titles.plural},
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
